import { createReducer } from 'redux-act';
import {
  setData,
  failGetData,
  successGetData,
  getData,
  putData,
} from '../actions/inquiry';
//[reducer] ../actions/{module_name}.jsで定義された内容を元に
//内部変数を変更する。
//component にて this.props.dispatch({actionName}());
//または
//redux-saga を使っている場合は ../saga/{module}.js から呼び出される。
//{actionName(param)} の引数param は props.dispatchで呼び出された場合は sagaに
// sagaで callによって呼び出されたときは reducer(このファイル)にて処理される。
//reducer を新規に作成した後は /reducer/index.js にも追記のこと。
//[actionName] :state =>
//[actionName] :(state,param) =>  ...{ationName(param)}
//[actionName] :() =>

//初期状態
const initial = {
  isFetching: false,
  data: [],
  error: undefined,
};

const data = createReducer(
  {
    [setData]: (state, payload) => Object.assign({}, state, payload),
    [failGetData]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successGetData]: (state, payload) =>
      Object.assign({}, state, payload, {
        isFetching: false,
        error: undefined,
      }),
    [getData]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [putData]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
  },
  initial
);

export default data;



// WEBPACK FOOTER //
// ./src/reducers/inquiry.js